module.exports = __webpack_public_path__ + "static/media/sort-arrow.0a8b01c0.svg";